import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import "./SajuList.css";
import io from "socket.io-client";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import {
  countByDate,
  countByGender,
  countByLanguage,
  countByType,
} from "../../utils/countByDate";
import {
  CombinedChart,
  FortuneChart,
  FortuneChartsByType,
  GenderChart,
  LanguageChart,
} from "./Chart";
import { useIsMobile } from "../../hooks/useIsMobile";
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);
const ENDPOINT = process.env.REACT_APP_END_POINT;

export default function SajuList() {
  let socket;
  socket = io(ENDPOINT);
  const data = {
    labels: ["월", "화", "수", "목", "금", "토", "일"],
    datasets: [
      {
        label: "채팅 메시지 수",
        data: [5, 8, 12, 7, 9, 3, 2],
        borderColor: "rgba(54, 162, 235, 1)",
        tension: 0, // 직선
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "요일별 채팅 수",
      },
      legend: {
        display: true,
        labels: {
          color: "#000", // 범례 글자색 (투명 배경에 대비용)
        },
      },
    },
  };
  const isMobile = useIsMobile();

  const [dateData, setDateData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [userLogin, setIsUserLogin] = useState(false);
  const [mobileId, setMobileId] = useState("");
  const [mobilePassword, setMobilePassword] = useState("");
  const messageList = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_END_POINT}fortunedata`
    );
    const data = await response.json();
    const dateData = data.chatInfo;
    const groupData = countByType(data.chatInfo);
    const languageData = countByLanguage(data.chatInfo);
    const genderData = countByGender(data.chatInfo);
    setDateData(dateData);
    setGroupData(groupData);
    setLanguageData(languageData);
    setGenderData(genderData);
  };

  const adminLogin = (adminName) => {
    setIsUserLogin(true);
    const date = new Date();
    const newUuid = uuidv4();

    localStorage.setItem(
      "adminInfo",
      JSON.stringify({
        userLogin: true,
        loginTime: date,
        adminName,
        uuid: newUuid,
      })
    );
  };
  useEffect(() => {
    messageList();
  }, []);
  return !userLogin ? (
    <div className="paddingDiv">
      <div className="managerLogin">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
            marginTop: 40,
          }}
        >
          <div
            style={{
              width: isMobile ? "100%" : 800,
              backgroundColor: "#fff", // 부모 컨테이너 배경
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              padding: "16px",
              borderRadius: "12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <CombinedChart fortuneData={dateData} />
          </div>
          <div
            style={{
              width: isMobile ? "100%" : 800,
              backgroundColor: "#fff", // 부모 컨테이너 배경
              padding: "16px",
              borderRadius: "12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <FortuneChartsByType fortuneData={groupData} />
          </div>
          <div
            style={{
              width: isMobile ? "100%" : 800,
              backgroundColor: "#fff", // 부모 컨테이너 배경
              padding: "16px",
              borderRadius: "12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <LanguageChart fortuneData={languageData} />
          </div>
          <div
            style={{
              width: isMobile ? "100%" : 800,
              backgroundColor: "#fff", // 부모 컨테이너 배경
              padding: "16px",
              borderRadius: "12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <GenderChart fortuneData={genderData} />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="paddingDiv">
      <div className="managerLogin">
        <h1 className="heading">관리자 로그인</h1>
        <div>
          {isMobile ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                rowGap: 30,
                justifyItems: "flex-start",
                fontSize: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                id{" "}
                <input
                  onChange={(e) => {
                    setMobileId(e.target.value);
                  }}
                  value={mobileId}
                  style={{ border: "none", borderRadius: 5, height: 30 }}
                />
              </div>
              <div>
                password{" "}
                <input
                  type="password"
                  onChange={(e) => {
                    setMobilePassword(e.target.value);
                  }}
                  value={mobilePassword}
                  style={{ border: "none", borderRadius: 5, height: 30 }}
                />
              </div>
              <button
                style={{
                  border: "none",
                  padding: 15,
                  borderRadius: 10,
                  backgroundColor: "#FFC028",
                  color: "white",
                  fontSize: 25,
                  fontWeight: 700,
                }}
                onClick={() => {
                  fetch(`${process.env.REACT_APP_END_POINT}mobile_login`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      id: mobileId,
                      password: mobilePassword,
                    }),
                  }).then(async (res) => {
                    const data = await res.json();
                    if (data !== "FAIL") {
                      adminLogin(data);
                    } else {
                      alert("아이디 및 비밀번호를 확인해주세요");
                    }
                  });
                }}
              >
                로그인
              </button>
            </div>
          ) : (
            <button
              className="googleLogin"
              onClick={() => {
                if (window.innerWidth < 500) {
                  setIsMobile(true);
                } else {
                  const openWindow = window.open("", "_blank");
                  openWindow.location =
                    "https://dev.moneyplex.kr/_plugin/social/popup2.php?provider=google";
                }
              }}
            >
              구글 로그인
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
